import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'
import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  phrases: [
    ...(filter.phrases || []),
    Array.from(insights).flatMap((insight) => [
      insight.name || insight.stemmedForm,
      ...(insight.variants || [])
    ])
  ]
})

const generateTermsInsightStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateTermsInsightStrategy
